"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringifyIpcBusService = void 0;
const is_object_1 = require("../util/lodash-functions/is-object");
class StringifyIpcBusService {
    constructor(ipcBusService) {
        this.ipcBusService = ipcBusService;
    }
    subscribe(channel, callback) {
        return this.ipcBusService.subscribe(channel, (subChannel, data) => {
            try {
                const parsedData = JSON.parse(data);
                callback(channel, (0, is_object_1.isObject)(parsedData) ? parsedData : data);
            }
            catch (err) {
                callback(subChannel, data);
            }
        });
    }
    unsubscribe(channel, callback) {
        return this.ipcBusService.unsubscribe(channel, callback);
    }
    publish(channel, data) {
        this.ipcBusService.publish(channel, (0, is_object_1.isObject)(data) ? JSON.stringify(data) : data);
    }
    connect() {
        return this.ipcBusService.connect();
    }
}
exports.StringifyIpcBusService = StringifyIpcBusService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5naWZ5LWlwYy1idXMtc2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pcGMtYnVzLXNlcnZpY2Uvc3RyaW5naWZ5LWlwYy1idXMtc2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxrRUFBOEQ7QUFHOUQsTUFBYSxzQkFBc0I7SUFDL0IsWUFBNkIsYUFBNEI7UUFBNUIsa0JBQWEsR0FBYixhQUFhLENBQWU7SUFBRyxDQUFDO0lBRXRELFNBQVMsQ0FBQyxPQUFlLEVBQUUsUUFBd0I7UUFDdEQsT0FBTyxJQUFJLENBQUMsYUFBYSxDQUFDLFNBQVMsQ0FBQyxPQUFPLEVBQUUsQ0FBQyxVQUFVLEVBQUUsSUFBSSxFQUFFLEVBQUU7WUFDOUQsSUFBSSxDQUFDO2dCQUNELE1BQU0sVUFBVSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7Z0JBQ3BDLFFBQVEsQ0FBQyxPQUFPLEVBQUUsSUFBQSxvQkFBUSxFQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ2hFLENBQUM7WUFBQyxPQUFPLEdBQUcsRUFBRSxDQUFDO2dCQUNYLFFBQVEsQ0FBQyxVQUFVLEVBQUUsSUFBSSxDQUFDLENBQUM7WUFDL0IsQ0FBQztRQUNMLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUVNLFdBQVcsQ0FBQyxPQUFlLEVBQUUsUUFBd0I7UUFDeEQsT0FBTyxJQUFJLENBQUMsYUFBYSxDQUFDLFdBQVcsQ0FBQyxPQUFPLEVBQUUsUUFBUSxDQUFDLENBQUM7SUFDN0QsQ0FBQztJQUVNLE9BQU8sQ0FBQyxPQUFlLEVBQUUsSUFBUztRQUNyQyxJQUFJLENBQUMsYUFBYSxDQUFDLE9BQU8sQ0FBQyxPQUFPLEVBQUUsSUFBQSxvQkFBUSxFQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN0RixDQUFDO0lBRU0sT0FBTztRQUNWLE9BQU8sSUFBSSxDQUFDLGFBQWEsQ0FBQyxPQUFPLEVBQUUsQ0FBQztJQUN4QyxDQUFDO0NBQ0o7QUF6QkQsd0RBeUJDIn0=